import type { ScreenContext } from './types.ts';
import { createCountdownTimer } from '@/components/countdown-timer.ts';

export function renderSilence(container: HTMLElement, { state, dispatch }: ScreenContext) {
  container.innerHTML = `
    <div class="card space-y-6 text-center">
      <div>
        <p class="text-sm uppercase tracking-wide text-gray-500">Breathing ${state.silenceIndex}</p>
        <h2 class="text-2xl font-semibold text-gray-900">30-second breathing pause</h2>
        <p class="text-gray-700 mt-1">Slow your breath and notice how your body feels now.</p>
      </div>
      <div id="timer-slot"></div>
      <p class="text-sm text-gray-600">We’ll move on automatically after 30 seconds.</p>
    </div>
  `;

  const timer = createCountdownTimer(30, () => {
    dispatch({ type: 'NEXT_PHASE' });
  });
  container.querySelector('#timer-slot')?.appendChild(timer.root);
  timer.start();
}
